import React from 'react';
import { useSequenceProjectCardBalance } from '../../hooks/useSequenceProjectCardBalance';
import { formatFinanceDateKey } from '../../utils/sequenceProjectCard';

const money = (n: number) =>
  n.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 });

export default function ProjectCardBalanceCheck({ amount }: { amount: number }) {
  const { loading, refreshing, pod, dateKey, error } = useSequenceProjectCardBalance(true);
  const short = pod != null && amount > pod.balance + 0.005;
  const leftover = pod != null ? pod.balance - amount : null;
  const asOf = formatFinanceDateKey(dateKey);

  return (
    <div
      className={`po-project-card${short ? ' po-project-card--short' : ''}`}
      aria-label="Sequence Project Card balance"
    >
      <div className="po-issued-kicker">Sequence Project Card</div>
      {loading && !pod ? <p className="po-project-card-copy">Checking Project Card balance…</p> : null}
      {pod ? (
        <>
          <div className="po-project-card-balance">{money(pod.balance)}</div>
          <p className="po-project-card-meta">
            {pod.name}
            {asOf ? ` · as of ${asOf}` : ''}
            {refreshing ? ' · refreshing…' : ''}
          </p>
          {short ? (
            <p className="po-project-card-warn">
              This PO is {money(amount)}. Move {money(amount - pod.balance)} onto the Project Card
              before it is charged.
            </p>
          ) : leftover != null ? (
            <p className="po-project-card-ok">{money(leftover)} left after this PO.</p>
          ) : null}
        </>
      ) : !loading ? (
        <p className="po-project-card-copy">
          {error
            ? 'Could not read the Sequence Project Card balance.'
            : 'Project Card pod not found in the latest Sequence snapshot.'}
        </p>
      ) : null}
    </div>
  );
}
